import { CLEAR_PAGE } from '../base/types';
import { FETCH_PRICES } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: []
};

const pricesReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_PRICES}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_PRICES}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_PRICES}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'prices' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default pricesReducer;
